<template>
	<div class="cog-generated-avatar cog-avatar" v-html="svg" />
</template>

<script lang="ts">
	import 'src/style/_brand-colors.scss';
	import { defineComponent } from 'vue';

	export default defineComponent({
		name: 'CGeneratedAvatar',
		props: {
			svg: {
				type: String,
				required: true
			}
		}
	});

</script>

<style lang="scss">
@import 'src/style/brand-colors';

@font-face {
	font-family: Gilroy;
	font-style: normal;
	font-weight: 800;
	src:
		url(https://static.cognitoforms.com/fonts/gilroy/gilroy-extrabold_basic-latin.woff2) format('woff2'),
		url(https://static.cognitoforms.com/fonts/gilroy/gilroy-extrabold_basic-latin.woff) format('woff');
	unicode-range: U+0020-007e, U+00a2-00ae, U+00B4, U+00B8, U+00BB, U+02C6, U+02DA, U+02DC;
}

@font-face {
	font-family: 'Gilroy Extra';
	font-style: normal;
	font-weight: 800;
	src:
		url(https://static.cognitoforms.com/fonts/gilroy/gilroy-extrabold_extra.woff2) format('woff2'),
		url(https://static.cognitoforms.com/fonts/gilroy/gilroy-extrabold_extra.woff) format('woff');
	unicode-range: U+00a1, U+00a4, U+00a6-00a8, U+00ac, U+00af, U+00b1, U+00b4-00b8, U+00bc-017e, U+0192, U+0218-021b, U+02c6, U+02c7, U+02d8-02dd, U+0300-030c, U+0326-0328, U+0401-045f, U+045f, U+0491;
}

#{$specificity-base} {

	.cog-generated-avatar {

		circle {
			stroke: hsla(var(--background-hsl), .2);
			stroke-width: 10;
			stroke-dasharray: none;
		}

		text {
			font-family: Gilroy, 'Gilroy Extra', 'Century Gothic', sans-serif;
			font-size: 144.7354px;
			font-weight: 800;
			fill: currentcolor;
		}
	}

	@each $cog-name, $cog-color in $cog-colors {
		.cog-#{$cog-name} {
			color: $cog-color;
		}
	}
}
</style>